import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/InfoOutlined';

import BaseDialog from '../../../components/BaseDialog/BaseDialog';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

function ExternalLinkModal(props) {
  const {
    classes,
    title,
    content,
    open,
    handleProceed,
    proceedLabel,
    handleBack,
    backLabel,
  } = props;

  return (
    <div className={classes.root}>
      <BaseDialog
        open={open}
        title={title}
        content={
          <React.Fragment>
            <Typography className={classes.dialogText} gutterBottom>
              {content}
            </Typography>
          </React.Fragment>
        }
        contentWrap={false}
        buttonAction={handleProceed}
        buttonLabel={proceedLabel}
        secondaryButtonAction={handleBack}
        secondaryButtonLabel={backLabel}
        icon={InfoIcon}
      />
    </div>
  );
}

ExternalLinkModal.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  handleProceed: PropTypes.func.isRequired,
  proceedLabel: PropTypes.string.isRequired,
  handleBack: PropTypes.func.isRequired,
  backLabel: PropTypes.string.isRequired,
};

ExternalLinkModal.defaultProps = {};

export default withStyles(styles)(ExternalLinkModal);
